import KeywordOpportunitiesContainer from './KeywordOpportunities.container';

export default KeywordOpportunitiesContainer;
